export default __webpack_public_path__ + "static/media/studentProfileView.3587f4eb.png";